import React, { Fragment } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import PlayStationButton from 'components/CTAButtons/PlayStationButton';
import * as cssVariable from 'cssVariables';
import SocialShare from 'components/SocialShare';
import { Station } from 'api/models';
import styles from './HeaderBanner.styles';
import Metadata from 'api/models/Metadata';
import { isTouch } from 'util/device';
import useBrowser from 'components/hooks/useBrowser';
import { breakpoints } from 'components/theme/breakpoints';
import ToggleFavoriteButton from 'components/ToggleFavoriteButton';
import ButtonTypes from '../Button/Button.const';

interface HeaderBanner {
  imageUrl: string;
  title: string;
  logoUrl: string;
  description: string;
  color: string;
  station: Station;
  metadata?: Metadata;
  isBrandPage?: boolean;
  showShare?: boolean;
}

const useStyles = createUseStyles(styles, { name: 'HeaderBanner' });
const HeaderBanner = (props: HeaderBanner): JSX.Element => {
  const { imageUrl, logoUrl, title, station, metadata, description, color, isBrandPage, showShare = true } = props;

  const browser = useBrowser();
  const classes = useStyles();

  const withTextFavBtn = browser.up(breakpoints.ml);

  const socialShareProps = {
    subject: title,
    description: metadata?.share?.description,
    link: metadata?.share?.url,
    title: metadata?.share?.title,
    size: 40,
    color: cssVariable.white,
  };

  return (
    <div className={classNames(classes.container, { [classes.containerTouch]: isTouch })} style={{ background: color }}>
      {logoUrl && <img data-testid="header-banner-logo" className={classes.logo} src={logoUrl} alt={title} />}
      <div className={classes.contentContainer}>
        <h1 className={classes.title}>{title}</h1>
        {description && <p className={classes.content}>{description}</p>}
      </div>
      <div className={classes.buttonContainer}>
        {station && !isBrandPage && (
          <Fragment>
            <PlayStationButton station={station} />
            {browser.up(breakpoints.xs) && (
              <ToggleFavoriteButton
                className={classNames({
                  [classes.minimalFavBtn]: !withTextFavBtn,
                })}
                data-testid="headerBanner-favourite"
                withText={withTextFavBtn}
                item={station}
                withAnalyticsData={{
                  'player_add-type': 'header',
                }}
                type={ButtonTypes.TERTIARY}
              />
            )}
          </Fragment>
        )}
        {metadata && showShare && browser.up(breakpoints.xs) && <SocialShare {...socialShareProps} />}
      </div>
      {imageUrl && <img className={classes.image} src={imageUrl} alt={title} />}
    </div>
  );
};

export default HeaderBanner;
